import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TabHomeComponent } from './tabs/tab-home/tab-home.component';
import { TabPassPredictionComponent } from './tabs/tab-pass-prediction/tab-pass-prediction.component';
import { TabDevicesComponent } from './tabs/tab-devices/tab-devices.component';
import { TabGatewaysComponent } from './tabs/tab-gateways/tab-gateways.component';
import { TabSystemStatusComponent } from './tabs/tab-system-status/tab-system-status.component';
import { TabAlmanacComponent } from './tabs/tab-almanac/tab-almanac.component';
import { TabDownloadsComponent } from './tabs/tab-downloads/tab-downloads.component';
import { TabSubscriptionsComponent } from './tabs/tab-subscriptions/tab-subscriptions.component';
import { TabSubscriptionsBuyComponent } from './tabs/tab-subscriptions/tab-subscriptions-buy.component';
import { TabSubscriptionsFleetComponent } from './tabs/tab-subscriptions/tab-subscriptions-fleet.component';
import { fleetPage, orderPages } from './services/subscription-order.service';
import { AuthGuard } from './auth-guard/auth-guard';
import { NotFoundComponent } from './not-found/not-found.component';
import {AdsAllow} from "./auth-guard/ads-allow";
import {KeycloakUserService} from "./services/keycloak-user.service";


export const routes: Routes = [
    // This order is maintained!
    // data index 0 will be rendered in the top nav when it has a positive number
  { path:'home',
    redirectTo: 'dashboard',
    pathMatch: 'full'},
  { path:'',
    redirectTo: 'dashboard',
    pathMatch: 'full'},
  { path:'dashboard',
    canActivate: [ AuthGuard ],
    title: 'Dashboard',
    component: TabHomeComponent,
    data: [0,'satellite_alt']  },
  { path:'devices',
    canActivate: [ AuthGuard ],
    title: 'Nodes',
    component: TabDevicesComponent,
    data: [2,'devices']  },
  { path:'pass_prediction',
    canActivate: [ AuthGuard ],
    title: 'Pass Prediction',
    component: TabPassPredictionComponent,
    data: [1,'satellite_alt']  },
  { path:'almanac',
    canActivate: [ AuthGuard ],
    title: 'Almanac Tools',
    component: TabAlmanacComponent,
    data: [4,'satellite']  },
  { path:'delivery_status',
    canActivate: [ AuthGuard ],
    title: 'Service Status',
    component: TabSystemStatusComponent,
    data: [3,'cloud_upload']  },
  {path:'Docs',
    title: 'Docs',
    redirectTo:'notfound',
    pathMatch: 'full',
    data: [5,'download','https://konflexhub.lacuna-space.com/docs']
  },
  { path:'downloads',
    canActivate: [ AuthGuard ],
    title: 'Resources',
    component: TabDownloadsComponent,
    data: [-1,'download']  },
  { path:'subscription',
    canActivate: [ AuthGuard ],
    title: 'Subscription',
    component: TabSubscriptionsComponent,
    data: [7,'subscriptions',undefined,'subscriptions']  },
  { path: orderPages.KIT,
    canActivate: [ AuthGuard ],
    title: 'KIT · nodes with connectivity',
    component: TabSubscriptionsBuyComponent,
    data: [-1,'subscriptions',undefined,'subscriptions','KIT']  },
  { path: orderPages.CONNECTIVITY_SINGLE,
    canActivate: [ AuthGuard ],
    title: 'Connectivity only',
    component: TabSubscriptionsBuyComponent,
    data: [-1,'subscriptions',undefined,'subscriptions','CONNECTIVITY_SINGLE']  },
  { path: fleetPage,
    canActivate: [ AuthGuard ],
    title: 'Fleet · connectivity plans',
    component: TabSubscriptionsFleetComponent,
    data: [-1,'subscriptions',undefined,'subscriptions']  },
  { path:'ads',
    canActivate: [ AuthGuard, AdsAllow ],
    title: 'ADS',
    component: TabGatewaysComponent,
    data: [6,'ads'] },
  {path:'notfound', component: NotFoundComponent },
  {path:'privacy-policy',redirectTo:'/privacy-policy.html',pathMatch: 'full'},
  {path:'**', redirectTo: 'notfound' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
